/**
 * BreadcrumbsItem
 * TODO: Check chevron color and direction
 */
import React from 'react';
import clsx from 'clsx';
import Icon from 'ui-component-library/base/Icon';
import { Link as LinkBase } from 'ui-component-library/base';
/** Main description for this component. */
var BreadcrumbsItem = function (_a) {
    var text = _a.text, url = _a.url, _b = _a.LinkComponent, LinkComponent = _b === void 0 ? LinkBase : _b, className = _a.className;
    var Link = LinkComponent;
    return (React.createElement("li", { className: clsx(className, 'breadcrumbs__item text-p md:text-l font-fontStandard'), "data-cid": "BreadcrumbsItem" }, url ? (React.createElement(Link, { to: url, className: "inline-flex items-center no-underline text-primary-2 hover:underline" },
        React.createElement(Icon, { icon: "chevron", size: 0.75, "aria-hidden": true, className: "breadcrumbs__back-icon md:hidden" }),
        text)) : (text)));
};
export default BreadcrumbsItem;
